import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import NoDataResource from '../../../common/resource/NoDataResource';
import BankBasicInformationResource from './resource/BankBasicInformationResource';
import { BANK_PATH } from '../../../../config/paths';
import { clearBank, getBank } from '../../../../actions';
import BankToolbar from './BankToolbar';

export const Bank = ({
  breadcrumbs,
  match: {
    params: { id: bankId },
  },
  bank,
  loading,
  dispatchGetBank,
  dispatchClearBank,
}) => {
  useLayoutEffect(() => {
    dispatchGetBank({ bankId });

    return () => dispatchClearBank();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (bank.isEmpty()) {
    content = <NoDataResource returnPage={BANK_PATH} />;
  } else {
    const bankJSON = bank.toJS();
    content = <BankBasicInformationResource {...bankJSON} />;
    toolbar = <BankToolbar bankId={bankJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Banco"
      toolbar={toolbar}
      content={content}
    />
  );
};

Bank.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  bank: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetBank: PropTypes.func.isRequired,
  dispatchClearBank: PropTypes.func.isRequired,
};

Bank.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Bancos',
      href: BANK_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  bank: AccountingUnit.Bank.getIn(['current', 'content']),
  loading: !AccountingUnit.Bank.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBank: getBank,
  dispatchClearBank: clearBank,
};

export default connect(mapStateToProps, mapDispatchToProps)(Bank);
